import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCircleUser,
  faCaretUp,
  faCaretDown,
} from '@fortawesome/free-solid-svg-icons';
import { AuthService } from 'shared/auth/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, FontAwesomeModule, NgOptimizedImage],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  private authService = inject(AuthService);
  faCircleUser = faCircleUser;
  faCaretUp = faCaretUp;
  faCaretDown = faCaretDown;
  username = signal('');
  isDropdownOpen = signal(false);
  readonly menuId = 'user-menu';

  tabs = [
    { label: 'Home', route: '/protected/home' },
    { label: 'Clients', route: '/protected/clients' },
    { label: 'Connector Types', route: '/protected/connector-types' },
    { label: 'Security', route: '/protected/security' },
  ];

  async ngOnInit(): Promise<void> {
    try {
      const user = await this.authService.getUser();
      this.username.set(user?.name || user?.email || 'User');
    } catch {
      this.username.set('User');
    }
  }

  toggleDropdown(): void {
    this.isDropdownOpen.update((v) => !v);
  }

  async onItemSelect(value: string): Promise<void> {
    this.isDropdownOpen.set(false);
    if (value === 'settings') {
      window.open('https://ntstcareconnect.okta.com/enduser/settings', '_blank');
    } else if (value === 'signOut') {
      await this.authService.signOut();
    }
  }
}
